import api from "./axios";

// Phase 4: agent-emitted Recommendation rows that the user approves or
// dismisses. The agent writes these via the emit_recommendation tool
// during a Council chat run; this client surfaces them in the Portfolio
// "Recommendations" sub-tab.

export const listMyRecommendations = async ({ status = "pending" } = {}) => {
  const res = await api.get("/api/recommendations/", { params: { status } });
  return res.data;
};

export const approveRecommendation = async (id) => {
  const res = await api.post(`/api/recommendations/${id}/approve/`);
  return res.data;
};

export const dismissRecommendation = async (id) => {
  const res = await api.post(`/api/recommendations/${id}/dismiss/`);
  return res.data;
};
